import { useEventCallback } from '@mui/material';
import {
  ContainerPopper,
  FakeDropdownBox,
  useDataGridContext,
  OwnerMultipleSelector,
  type ExtendedGridColumnHeaderProps,
  type GroupedUserDto,
} from '@issuemanager/apps/client/components';
import { OwnerColumnFilter } from '@issuemanager/client/features/issues';
import type { IssueGridFilterModel } from './types';

export function IssueGridOwnerFilter(_: ExtendedGridColumnHeaderProps) {
  const context = useDataGridContext();
  const issueOwners: IssueGridFilterModel['owner'] = context.filterModel.owner;
  const actionOwners: IssueGridFilterModel['actionOwner'] =
    context.filterModel.actionOwner;

  const value: GroupedUserDto[] = (issueOwners ?? []).concat(
    actionOwners ?? [],
  );

  const handleChange = useEventCallback((value: GroupedUserDto[]) => {
    const owner = value.filter(
      (v) => v.group === OwnerColumnFilter.ISSUE_OWNER,
    );
    const actionOwner = value.filter(
      (v) => v.group === OwnerColumnFilter.ACTION_OWNER,
    );
    context.setFilterModel((prevState) => ({
      ...prevState,
      owner,
      actionOwner,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0 ? value.map((c) => c.name).join(', ') : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <OwnerMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
